import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import { DemoMap } from 'features/maps/types'
import MapCard from 'features/maps/ui/MapCard/MapCard'
import { useAppSelector } from 'app/state'
import useDemoMaps from 'features/maps/utils/useDemoMaps'
import { useAccountQuotas } from 'features/quotas/ui/hooks'
import { useHardQuotaModalController } from 'features/quotas/ui/WouldExceedQuotaDialog'
import MapsHardQuotaModal from 'features/maps/ui/MapsHardQuotaModal'
import { QuotaUxTrigger } from 'features/hubspot/types'

export function HomeDemoMaps({ maps }: { maps: DemoMap[] }) {
  const creatingDemoMapsIds = useAppSelector((state) => state.maps.creatingDemoMapsIds)
  const { mapsQuota } = useAccountQuotas()

  const { openDemoMap, openDemoMapAction } = useDemoMaps()
  const hardQuotaModalController = useHardQuotaModalController(mapsQuota, openDemoMapAction)

  const handleMapClick = useCallback(
    (map) => {
      openDemoMap(map)
    },
    [openDemoMap]
  )

  return (
    <>
      {maps.map((map) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={map.id}>
            <MapCard
              map={map}
              loading={(map.id && creatingDemoMapsIds.includes(map.id)) || false}
              loadingMessage={<FormattedMessage id="maps.creatingDemoMap" />}
              onClick={() => handleMapClick(map)}
              demo={true}
            />
          </Grid>
        )
      })}
      <MapsHardQuotaModal {...hardQuotaModalController.props} variant="create" quotaUxTrigger={QuotaUxTrigger.NewMap} />
    </>
  )
}

export default HomeDemoMaps
